export const environment = {
  production: true,
  PIVOT_CLIENT_API_URL: 'https://api.stage.pivot.ck1lab.net/',
  IMAGE_FOLDER: 'user-img',
  USER_DATA_URL: 'https://d2g38ktg9elmkf.cloudfront.net/',
  CKPASS_FORGOT_PW: 'https://stage-pass.devkarte.jp/forgot-password?module=pivot',
  CKPASS_WEBAPP_URL: 'https://stage-pass.devkarte.jp/',
  SAUCER_LOG_API_URL:'https://api.stage.saucerlog.ck1lab.net/',
  SAUCER_LOG_TOKEN:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtb2R1bGUiOiJQSVZPVCIsImlhdCI6MTcwODkwNTYwMH0.ZoKoqIT35J9JU6dh2xQVh0GJb8z-eS9OhXj7mhmXwsg'
};
